import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useGlobal from 'global-state/store';

export default function AdminOnlineGate() {
  const { t } = useTranslation();
  const [state] = useGlobal();
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);
  return (
    <>
      <Outlet />
      <Dialog open={!online || state.networkState === 'offline'} disableEscapeKeyDown>
        <DialogTitle>{t('admin.connection_required')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('admin.connection_required_details')}</DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
